import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class ActivityServiceService {

  private baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient, private dataService: DataService) { }

  getActivityList(SearchQuery: any) {
    return this.dataService.getRecordWithParams('/api/activity/getActivityList', SearchQuery);
  };

  saveActivity(searchQuery:any) {

    return this.dataService.post('/api/activity/postActivity', searchQuery);
  };

  getActivity(activityId: number) {
    return this.dataService.getRecord('/api/activity/getActivity/?activityId=' + activityId);
  }

  deleteActivity(activityId:number) {
    return this.dataService.delete('/api/activity/deleteActivity/?activityId=' + activityId);
  }

  saveApplicationActivity(saveApplicationActivity: any) {

    return this.dataService.post('/api/activity/postApplicationActivity', saveApplicationActivity);
  }

  getApplicationActivity(applicationActivityId:number) {
    return this.dataService.getRecord('/api/activity/getApplicationActivity/?applicationActivityId=' + applicationActivityId);
  }


  getManageActionList(SearchQuery:any) {
    return this.dataService.getRecordWithParams('/api/activity/getManageActionList', SearchQuery);
  };

  getPreviousActionList(SearchQuery:any) {
    return this.dataService.getRecordWithParams('/api/activity/getPreviousActionList', SearchQuery);
  };

  saveActionTaken(searchQuery:any) {
    return this.dataService.post('/api/actionTaken/postActivity', searchQuery);
  };
}
